import React from "react";
import { motion } from "framer-motion";
import CTASectionWrapper from "@/components/CTASectionWrapper";
import CTASectionHeading from "@/components/CTASectionHeading";
import CTAButton from "@/components/CTAButton";
import { useTranslation } from "react-i18next";

const AuthorSection = () => {
  const { t } = useTranslation();
  
  return (
    <CTASectionWrapper className="py-24 bg-black">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="flex flex-col justify-center space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold text-white">
              {t('cta.author.title')}
            </h2>
            
            <p className="text-white/80 text-lg">
              {t('cta.author.description')}
            </p>
            
            <div className="pt-4">
              <CTAButton 
                customRedirect="author"
                className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2"
              >
                {t('cta.author.button')}
              </CTAButton>
            </div>
          </div>
          
          {/* Right Content - Image */}
          <div className="order-first lg:order-last relative aspect-video w-full overflow-hidden rounded-lg">
            {/* Subtle gradient overlay */}
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-black/0 to-black/10 z-10"
            />
            
            {/* Using the new bookshop/coffee image with a key to force re-render and avoid caching */}
            <img 
              key="author-image-2"
              src="/lovable-uploads/d525a06b-276a-466a-b683-e3f464bd460e.webp"
              alt="Cozy bookshop with coffee"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </div>
      </div>
    </CTASectionWrapper>
  );
};

export default AuthorSection;
